import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class MatomoService {
    private initialized = false;

    initializeTagManager(): void {
        if (!environment.matomo.enabled || this.initialized) return;
        // @ts-ignore
        const matomoInstances = window._mtm || [];
        matomoInstances.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });

        // @ts-ignore
        window._mtm = matomoInstances;

        const firstScriptElement =
            document.getElementsByTagName('script')[0];

        const matomoScriptElement = document.createElement('script');
        matomoScriptElement.type = 'text/javascript';
        matomoScriptElement.async = true;
        matomoScriptElement.defer = true;
        matomoScriptElement.src = environment.matomo.url;

        firstScriptElement?.parentNode?.insertBefore(
            matomoScriptElement,
            firstScriptElement
        );

        this.initialized = true;
    }
}